import React from "react";

// Source
import StoreRoute from "../../store/Route";
import StoreRole from "../../store/Role";
import StoreLocalization from "../../store/Localization";
import StorePreference from "../../store/Preference";
import * as HelperSrc from "../../HelperSrc";
import * as ModelPagination from "../../model/Pagination";
import * as ModelRoute from "../../model/Route";
import * as ModelCustomRoute from "../../model/custom/Route";
import * as ModelRole from "../../model/Role";
import * as ModelLocalization from "../../model/Localization";
import * as ModelCustomLocalization from "../../model/custom/Localization";
import * as ModelPreference from "../../model/Preference";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ApiPayment from "../../api/custom/Payment";
import * as ApiPayer from "../../api/custom/Payer";
import * as ModelPayment from "../../model/custom/Payment";
import * as ModelInvoice from "../../model/custom/Invoice";
import * as ModelPayer from "../../model/custom/Payer";
import ControllerAlert from "../Alert";

export default class ControllerPaymentList {
    // Variable
    private storeRoute: ModelRoute.Istore<ModelCustomRoute.Idata>;
    private storageRouteData = React.useRef<ModelCustomRoute.Idata | undefined>(undefined);
    private storeRole: ModelRole.Istore;
    private storageRoleData = React.useRef<ModelRole.Idata | undefined>(undefined);
    private storeLocalization: ModelLocalization.Istore<ModelCustomLocalization.Idata>;
    private storageLocalizationData = React.useRef<ModelCustomLocalization.Idata | undefined>(undefined);
    private storePreference: ModelPreference.Istore<ModelPreference.Idata>;
    private storagePreferenceData = React.useRef<ModelPreference.Idata | undefined>(undefined);

    private controllerAlert: ControllerAlert;

    private elementDate = React.useRef<HTMLInputElement | null>(null);
    private elementClientId = React.useRef<HTMLInputElement | null>(null);
    private elementLatestUpdate = React.useRef<HTMLInputElement | null>(null);
    private elementLatestUpdateById = React.useRef<HTMLInputElement | null>(null);
    private elementViewMainPi = React.useRef<HTMLElement | null>(null);
    private elementViewMainFr = React.useRef<HTMLElement | null>(null);
    private elementViewMainPd = React.useRef<HTMLElement | null>(null);
    private elementPiInvoiceTable = React.useRef<HTMLElement | null>(null);

    private isRendered = React.useRef<boolean>(false);
    private filter = React.useRef<ModelPagination.CustomPagination.IfilterPayment | undefined>(undefined);
    private dataMainList = React.useRef<ModelPayment.Idata[] | undefined>(undefined);
    private dataInvoiceList = React.useRef<ModelInvoice.Idata[] | undefined>(undefined);
    private dataInvoicePiList = React.useRef<ModelInvoice.Idata[][] | undefined>(undefined);
    private rowIdMain = React.useRef<number>(0);
    private selectOption = React.useRef<ModelPayment.IselectOption | undefined>(undefined);
    private idRemove = React.useRef(0);
    private language = React.useRef<string>("");

    getStorageRole: ModelRole.Idata | undefined;

    getApiLoadingList: Record<string, boolean | undefined>;
    setApiLoadingList: React.Dispatch<React.SetStateAction<Record<string, boolean | undefined>>>;

    getSelectOption: ModelPayment.IselectOption | undefined;
    setSelectOption: React.Dispatch<React.SetStateAction<ModelPayment.IselectOption | undefined>>;

    getIsDialogOpen: boolean;
    setIsDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;

    getPagination: ModelPagination.Idata | undefined;
    setPagination: React.Dispatch<React.SetStateAction<ModelPagination.Idata | undefined>>;

    getFilter: ModelPayment.Idata | undefined;
    setFilter: React.Dispatch<React.SetStateAction<ModelPayment.Idata | undefined>>;

    getDataMainList: ModelPayment.Idata[] | undefined;
    setDataMainList: React.Dispatch<React.SetStateAction<ModelPayment.Idata[] | undefined>>;

    getDataInvoiceList: ModelInvoice.Idata[] | undefined;
    setDataInvoiceList: React.Dispatch<React.SetStateAction<ModelInvoice.Idata[] | undefined>>;

    getDataInvoicePiList: ModelInvoice.Idata[][] | undefined;
    setDataInvoicePiList: React.Dispatch<React.SetStateAction<ModelInvoice.Idata[][] | undefined>>;

    getUrlFile: string | undefined;
    setUrlFile: React.Dispatch<React.SetStateAction<string | undefined>>;

    getIsSaveVisibleList: Record<number, boolean> | undefined;
    setIsSaveVisibleList: React.Dispatch<React.SetStateAction<Record<number, boolean> | undefined>>;

    getIsRemoveDialogOpen: boolean;
    setIsRemoveDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;

    getLanguage: string;
    setLanguage: React.Dispatch<React.SetStateAction<string>>;

    getElementDateValue: string;
    setElementDateValue: React.Dispatch<React.SetStateAction<string>>;

    getElementClientIdValue: string;
    setElementClientIdValue: React.Dispatch<React.SetStateAction<string>>;

    getElementLatestUpdateByIdValue: string;
    setElementLatestUpdateByIdValue: React.Dispatch<React.SetStateAction<string>>;

    // Method
    constructor(isRendered: boolean) {
        this.storeRoute = new StoreRoute();
        this.storageRouteData.current = this.storeRoute.storageGet();
        this.storeRole = new StoreRole();
        this.storageRoleData.current = this.storeRole.storageGet();
        this.storeLocalization = new StoreLocalization();
        this.storageLocalizationData.current = this.storeLocalization.storageGet();
        this.storePreference = new StorePreference();
        this.storagePreferenceData.current = this.storePreference.storageGet();

        this.controllerAlert = new ControllerAlert(isRendered);

        this.isRendered.current = isRendered;

        const [getStorageRole] = React.useState<ModelRole.Idata | undefined>(this.storageRoleData.current);
        this.getStorageRole = getStorageRole;

        const [getApiLoadingList, setApiLoadingList] = React.useState<Record<string, boolean | undefined>>({});
        this.getApiLoadingList = getApiLoadingList;
        this.setApiLoadingList = setApiLoadingList;

        const [getSelectOption, setSelectOption] = React.useState<ModelPayment.IselectOption | undefined>(undefined);
        this.getSelectOption = getSelectOption;
        this.setSelectOption = setSelectOption;

        const [getIsDialogOpen, setIsDialogOpen] = React.useState(false);
        this.getIsDialogOpen = getIsDialogOpen;
        this.setIsDialogOpen = setIsDialogOpen;

        const [getPagination, setPagination] = React.useState<ModelPagination.Idata | undefined>(undefined);
        this.getPagination = getPagination;
        this.setPagination = setPagination;

        const [getFilter, setFilter] = React.useState<ModelPayment.Idata | undefined>(undefined);
        this.getFilter = getFilter;
        this.setFilter = setFilter;

        const [getDataMainList, setDataMainList] = React.useState<ModelPayment.Idata[] | undefined>(this.dataMainList.current);
        this.getDataMainList = getDataMainList;
        this.setDataMainList = setDataMainList;

        const [getDataInvoiceList, setDataInvoiceList] = React.useState<ModelInvoice.Idata[] | undefined>(this.dataInvoiceList.current);
        this.getDataInvoiceList = getDataInvoiceList;
        this.setDataInvoiceList = setDataInvoiceList;

        const [getDataInvoicePiList, setDataInvoicePiList] = React.useState<ModelInvoice.Idata[][] | undefined>(this.dataInvoicePiList.current);
        this.getDataInvoicePiList = getDataInvoicePiList;
        this.setDataInvoicePiList = setDataInvoicePiList;

        const [getUrlFile, setUrlFile] = React.useState<string | undefined>(undefined);
        this.getUrlFile = getUrlFile;
        this.setUrlFile = setUrlFile;

        const [getIsSaveVisibleList, setIsSaveVisibleList] = React.useState<Record<number, boolean> | undefined>(undefined);
        this.getIsSaveVisibleList = getIsSaveVisibleList;
        this.setIsSaveVisibleList = setIsSaveVisibleList;

        const [getIsRemoveDialogOpen, setIsRemoveDialogOpen] = React.useState(false);
        this.getIsRemoveDialogOpen = getIsRemoveDialogOpen;
        this.setIsRemoveDialogOpen = setIsRemoveDialogOpen;

        const [getLanguage, setLanguage] = React.useState<string>(this.language.current);
        this.getLanguage = getLanguage;
        this.setLanguage = setLanguage;

        const [getElementDateValue, setElementDateValue] = React.useState<string>("");
        this.getElementDateValue = getElementDateValue;
        this.setElementDateValue = setElementDateValue;

        const [getElementClientIdValue, setElementClientIdValue] = React.useState<string>("");
        this.getElementClientIdValue = getElementClientIdValue;
        this.setElementClientIdValue = setElementClientIdValue;

        const [getElementLatestUpdateByIdValue, setElementLatestUpdateByIdValue] = React.useState<string>("");
        this.getElementLatestUpdateByIdValue = getElementLatestUpdateByIdValue;
        this.setElementLatestUpdateByIdValue = setElementLatestUpdateByIdValue;
    }

    initializeHook = (mode: string): void => {
        let className = "";

        if (mode === "pi") {
            className = ".view_payment_pi_list";
        } else if (mode === "fr") {
            className = ".view_payment_fr_list";
        } else if (mode === "pd") {
            className = ".view_payment_pd_list";
        }

        React.useEffect(() => {
            HelperSrc.domObserver(className, () => {
                this.initializeHtmlElement();
            });

            this.apiSelectOption(mode);

            this.apiDataList(mode);
        }, []);

        React.useEffect(() => {
            this.storageRouteData.current = this.storeRoute.storageGet();
            this.storageRoleData.current = this.storeRole.storageGet();
            this.storageLocalizationData.current = this.storeLocalization.storageGet();
        }, [this.storageRouteData.current, this.storageRoleData.current, this.storageLocalizationData.current]);

        React.useEffect(() => {
            this.storagePreferenceData.current = this.storePreference.storageGet();

            if (this.storagePreferenceData.current) {
                const initialLanguage = this.language.current;

                if (this.language.current !== this.storagePreferenceData.current.language) {
                    this.language.current = this.storagePreferenceData.current.language;
                    this.setLanguage(this.language.current);

                    if (initialLanguage !== "") {
                        this.apiSelectOption(mode);
                    }
                }
            }
        }, [this.storagePreferenceData.current]);
    };

    apiDataList = (mode: string, isFilter = false): void => {
        this.filterParameter(mode, isFilter);

        if (this.filter.current) {
            this.setApiLoadingList((prev) => ({
                ...prev,
                dataList: true
            }));

            ApiPayment.dataList(mode, this.filter.current, this.filter.current.sort_order, this.filter.current.page, (response) => {
                this.setApiLoadingList((prev) => ({
                    ...prev,
                    dataList: false
                }));

                if (response instanceof Error || response.message.error) {
                    if (response instanceof Error) {
                        HelperSrc.writeLog("error", response.message);
                    } else {
                        this.controllerAlert.show("error", response.message.error, false);
                    }

                    return;
                }

                this.setPagination(response.pagination);

                this.dataMainList.current = response.pagination.data as unknown as ModelPayment.Idata[];
                this.setDataMainList(this.dataMainList.current);

                for (const [dataMainIndex, dataMain] of Object.entries(this.dataMainList.current)) {
                    ApiPayment.payerLimit(dataMain.id, (response) => {
                        if (response instanceof Error || response.message.error) {
                            if (response instanceof Error) {
                                HelperSrc.writeLog("error", response.message);
                            } else {
                                this.controllerAlert.show("error", response.message.error, false);
                            }

                            return;
                        }

                        const resultPayerLimitList = response.data.result as unknown as Record<string, number>;
                        let isSaveVisible = true;

                        for (const [invoiceIndex, invoice] of Object.entries(dataMain.invoice)) {
                            for (const [invoiceItemIndex, invoiceItem] of Object.entries(invoice.item)) {
                                const paymentAmount = parseInt(invoiceItem.payment_amount);
                                const isEnoughMoney = paymentAmount <= resultPayerLimitList[invoiceItem.payer_id];

                                if (this.dataMainList.current) {
                                    this.dataMainList.current[dataMainIndex].invoice[invoiceIndex].item[invoiceItemIndex]["isAlert"] = !isEnoughMoney;
                                }

                                isSaveVisible = isSaveVisible && isEnoughMoney;

                                resultPayerLimitList[invoiceItem.payer_id] -= paymentAmount;
                            }
                        }

                        this.setDataMainList(this.dataMainList.current);

                        this.setIsSaveVisibleList((prev) => ({
                            ...prev,
                            [dataMain.id]: isSaveVisible
                        }));
                    });
                }

                this.controllerAlert.show("success", response.message.success);
            });
        }
    };

    clickCreate = (): void => {
        if (this.storageRouteData.current) {
            HelperSrc.routerHistoryPush(this.storageRouteData.current.payment_profile.path);
        }
    };

    clickFilterApply = (mode: string): void => {
        this.apiDataList(mode, true);
    };

    clickDialogOpen = (id: number): void => {
        this.rowIdMain.current = id;

        this.setApiLoadingList((prev) => ({
            ...prev,
            invoiceDataList: true
        }));

        ApiPayment.invoiceDataList("desc", "1", id, (response) => {
            this.setApiLoadingList((prev) => ({
                ...prev,
                invoiceDataList: false
            }));

            if (response instanceof Error || response.message.error) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response.message);
                } else {
                    this.controllerAlert.show("error", response.message.error, false);
                }

                return;
            }

            this.dataInvoiceList.current = response.pagination.data as unknown as ModelInvoice.Idata[];
            this.setDataInvoiceList(this.dataInvoiceList.current);

            this.setIsDialogOpen(true);

            this.elementPiInvoiceTable.current = document.querySelector<HTMLElement>(".table_payment_pi_invoice");
        });
    };

    clickDialogClose = (): void => {
        if (this.elementPiInvoiceTable.current) {
            const elementEheckboxList = this.elementPiInvoiceTable.current.querySelectorAll(
                ".row input[name='selected_invoice']"
            ) as unknown as HTMLInputElement;

            if (!this.dataInvoicePiList.current) {
                this.dataInvoicePiList.current = [];
            }

            this.dataInvoicePiList.current[this.rowIdMain.current] = [];

            for (const data of Object.values(elementEheckboxList)) {
                if (data.checked) {
                    const elementRow = data.closest(".row");
                    const elementId = elementRow.querySelector(".cell.id") as HTMLElement;

                    if (this.dataInvoiceList.current && elementId) {
                        const id = parseInt(elementId.innerText);

                        for (const dataSub of Object.values(this.dataInvoiceList.current)) {
                            if (dataSub.id === id) {
                                this.dataInvoicePiList.current[this.rowIdMain.current].push(dataSub);
                            }
                        }
                    }
                }
            }
        }

        this.setDataInvoicePiList(this.dataInvoicePiList.current);

        this.setIsDialogOpen(false);
    };

    clickSavePi = (id: number): void => {
        this.rowIdMain.current = id;

        let invoice = {};

        if (this.dataInvoicePiList.current) {
            for (const data of Object.values(this.dataInvoicePiList.current[id])) {
                invoice[data.id] = data.detail;
            }
        }

        this.setApiLoadingList((prev) => ({
            ...prev,
            savePi: true
        }));

        ApiPayment.create_pi(id, invoice, (response) => {
            if (response instanceof Error || response.message.error) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response.message);
                } else {
                    this.controllerAlert.show("error", response.message.error, false);
                }

                this.setApiLoadingList((prev) => ({
                    ...prev,
                    savePi: false
                }));

                return;
            }

            this.controllerAlert.show("success", response.message.success);

            const elementIdList = document.querySelectorAll(".tbody_payment_pi_list .row .cell.id") as unknown as HTMLElement[];

            for (const elementId of elementIdList) {
                const id = parseInt(elementId.innerText);

                if (id === this.rowIdMain.current) {
                    const elementRow = elementId.closest(".row");

                    if (elementRow) {
                        elementRow.remove();
                    }

                    if (this.dataInvoicePiList.current) {
                        delete this.dataInvoicePiList.current[this.rowIdMain.current];
                        const updatedList = [...this.dataInvoicePiList.current];
                        this.setDataInvoicePiList(updatedList);
                    }
                }
            }
        });
    };

    clickSavePd = (id: number): void => {
        this.rowIdMain.current = id;

        this.setApiLoadingList((prev) => ({
            ...prev,
            savePd: true
        }));

        ApiPayment.create_pd(id, (response) => {
            if (response instanceof Error || response.message.error) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response.message);
                } else {
                    this.controllerAlert.show("error", response.message.error, false);
                }

                this.setApiLoadingList((prev) => ({
                    ...prev,
                    savePd: false
                }));

                return;
            }

            this.controllerAlert.show("success", response.message.success);

            const elementIdList = document.querySelectorAll(".tbody_payment_fr_list .row .cell.id") as unknown as HTMLElement[];

            for (const elementId of elementIdList) {
                const id = parseInt(elementId.innerText);

                if (id === this.rowIdMain.current) {
                    if (this.dataMainList.current) {
                        const updatedList = [] as ModelPayment.Idata[];

                        for (const item of this.dataMainList.current) {
                            if (item.id !== this.rowIdMain.current) {
                                updatedList.push(item);
                            }
                        }

                        this.dataMainList.current = updatedList;
                        this.setDataMainList(updatedList);
                    }
                }
            }
        });
    };

    clickRemove = (event: React.MouseEvent<SVGSVGElement, MouseEvent>, id: number): void => {
        event.stopPropagation();

        this.idRemove.current = id;

        this.setIsRemoveDialogOpen(true);
    };

    clickDialogRemoveConfirm = (mode: string): void => {
        if (this.idRemove.current > 0) {
            this.setApiLoadingList((prev) => ({
                ...prev,
                removeData: true
            }));

            ApiPayment.removeData(this.idRemove.current, (response) => {
                this.setApiLoadingList((prev) => ({
                    ...prev,
                    removeData: false
                }));

                this.setIsRemoveDialogOpen(false);

                if (response instanceof Error || response.message.error) {
                    if (response instanceof Error) {
                        HelperSrc.writeLog("error", response.message);
                    } else {
                        this.controllerAlert.show("error", response.message.error, false);
                    }

                    return;
                }

                this.controllerAlert.show("success", response.message.success);

                this.apiDataList(mode);
            });
        }
    };

    clickDialogRemoveCancel = (): void => {
        this.setIsRemoveDialogOpen(false);
    };

    onClickPayer = (id: number): void => {
        if (this.storageRouteData.current) {
            ApiPayer.profileData(id, (response) => {
                if (response instanceof Error || response.message.error) {
                    if (response instanceof Error) {
                        HelperSrc.writeLog("error", response.message);
                    } else {
                        this.controllerAlert.show("error", response.message.error, false);
                    }

                    return;
                }

                const resultList = response.data.result as unknown as ModelPayer.Idata[];

                if (this.storageRouteData.current) {
                    HelperSrc.routerHistoryPush(
                        this.storageRouteData.current.payer_profile.path,
                        resultList[0] as unknown as Record<string, unknown>
                    );
                }
            });
        }
    };

    private initializeHtmlElement = (): void => {
        if (!this.elementViewMainPi.current || !this.elementViewMainFr.current || !this.elementViewMainPd.current) {
            this.elementDate.current = document.querySelector<HTMLInputElement>("[name='date']");
            this.elementClientId.current = document.querySelector<HTMLInputElement>("[name='client_id']");
            this.elementLatestUpdate.current = document.querySelector<HTMLInputElement>("[name='latest_update']");
            this.elementLatestUpdateById.current = document.querySelector<HTMLInputElement>("[name='latest_update_by_id']");
            this.elementViewMainPi.current = document.querySelector<HTMLElement>(".view_payment_pi_list");
            this.elementViewMainFr.current = document.querySelector<HTMLElement>(".view_payment_tr_list");
            this.elementViewMainPd.current = document.querySelector<HTMLElement>(".view_payment_pd_list");
        }
    };

    private apiSelectOption = (mode: string): void => {
        this.setApiLoadingList((prev) => ({
            ...prev,
            selectOption: true
        }));

        ApiPayment.selectOption(mode, (response) => {
            this.setApiLoadingList((prev) => ({
                ...prev,
                selectOption: false
            }));

            if (response instanceof Error || response.message.error) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response.message);
                } else {
                    this.controllerAlert.show("error", response.message.error, false);
                }

                return;
            }

            this.selectOption.current = response.data.result as unknown as ModelPayment.IselectOption;

            this.setSelectOption(this.selectOption.current);
        });
    };

    private filterParameter = (mode: string, isFilter: boolean): void => {
        const pageUrl = HelperSrc.urlVariable("page") && !isFilter ? HelperSrc.urlVariable("page") : "1";
        const sortOrderUlr = HelperSrc.urlVariable("sort_order") && !isFilter ? HelperSrc.urlVariable("sort_order") : "desc";
        const dateUrl = HelperSrc.urlVariable("date") && !isFilter ? HelperSrc.urlVariable("date") : "";
        const clientIdUrl = HelperSrc.urlVariable("client_id") && !isFilter ? HelperSrc.urlVariable("client_id") : "";
        const latestUpdateUrl = HelperSrc.urlVariable("latest_update") && !isFilter ? HelperSrc.urlVariable("latest_update") : "";
        const latestUpdateByIdUrl = HelperSrc.urlVariable("latest_update_by_id") && !isFilter ? HelperSrc.urlVariable("latest_update_by_id") : "";

        const dateResult = this.elementDate.current && this.elementDate.current.value !== dateUrl ? this.elementDate.current.value : dateUrl;
        const clientIdResult =
            this.elementClientId.current && this.elementClientId.current.value !== clientIdUrl ? this.elementClientId.current.value : clientIdUrl;
        const latestUpdateResult =
            this.elementLatestUpdate.current && this.elementLatestUpdate.current.value !== latestUpdateUrl
                ? this.elementLatestUpdate.current.value
                : latestUpdateUrl;
        const latestUpdateByIdResult =
            this.elementLatestUpdateById.current && this.elementLatestUpdateById.current.value !== latestUpdateByIdUrl
                ? this.elementLatestUpdateById.current.value
                : latestUpdateByIdUrl;

        this.filter.current = {
            page: pageUrl,
            sort_order: sortOrderUlr,
            date: dateResult as string & ModelHelperSrc.IvalidationForm,
            client_id: clientIdResult as unknown as number & ModelHelperSrc.IvalidationForm,
            latest_update: latestUpdateResult as string & ModelHelperSrc.IvalidationForm,
            latest_update_by_id: latestUpdateByIdResult as unknown as number & ModelHelperSrc.IvalidationForm
        } as unknown as ModelPagination.CustomPagination.IfilterPayment;
        this.setFilter(this.filter.current);

        if (this.storageRouteData.current) {
            let url = "";

            if (mode === "pi") {
                url = this.storageRouteData.current.payment_pi_list.path;
            } else if (mode === "fr") {
                url = this.storageRouteData.current.payment_fr_list.path;
            } else if (mode === "pd") {
                url = this.storageRouteData.current.payment_pd_list.path;
            }

            HelperSrc.routerHistoryPush(
                `${url}?page=${this.filter.current.page}&sort_order=${this.filter.current.sort_order}&` +
                    `date=${this.filter.current.date}&` +
                    `client_id=${this.filter.current.client_id}&` +
                    `latest_update=${this.filter.current.latest_update}&` +
                    `latest_update_by_id=${this.filter.current.latest_update_by_id}`,
                {},
                "",
                true
            );
        }
    };
}
